"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAIHLQATaskView = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const classnames_1 = __importDefault(require("classnames"));
const react_router_1 = require("react-router");
const use_selected_tree_node_for_task_view_hook_1 = require("./hooks/use-selected-tree-node-for-task-view.hook");
const use_task_view_query_params_hook_1 = require("./hooks/use-task-view-query-params.hook");
const products_table_1 = require("./partials/products-table");
const request_full_qa_action_1 = require("./partials/request-full-qa-action");
const sidebar_component_1 = require("./partials/sidebar/sidebar.component");
const task_view_styles_1 = require("./task-view.styles");
const context_1 = require("../../context");
const enrich_ai_styles_1 = require("../../enrich-ai.styles");
const generic_1 = require("../../generic");
const task_view_1 = require("../../store/catalogs/task-view");
const generic_2 = require("../../../generic");
const localization_1 = require("../../../localization");
const EnrichAIHLQATaskView = () => {
    const isSidebarOpen = (0, task_view_1.useTaskViewProductsTableIsSidebarOpen)();
    const { searchParams, isLoading, } = (0, use_task_view_query_params_hook_1.useTaskViewQueryParams)();
    const navigate = (0, react_router_1.useNavigate)();
    const { isReEnrichmentInProgress } = (0, context_1.useCatalogActivityProgressContext)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const productTreeNode = (0, use_selected_tree_node_for_task_view_hook_1.useSelectedTreeNodeForTaskView)();
    const { title: terminalNodeName = '' } = productTreeNode || {};
    const onGoBack = (0, react_1.useCallback)(() => {
        // TODO get proper back path when redirecting to this page and use here
        navigate('..', { relative: 'path' });
    }, [navigate]);
    const { attributeName } = searchParams;
    (0, react_1.useEffect)(() => {
        if (!attributeName) {
            onGoBack();
        }
    }, [attributeName, onGoBack]);
    if (isLoading || !productTreeNode) {
        return react_1.default.createElement(generic_2.SimpleLoading, null);
    }
    return (react_1.default.createElement(enrich_ai_styles_1.StyledPageContainer, { className: (0, classnames_1.default)('task-view', { 'sidebar-open': isSidebarOpen }) }, react_1.default.createElement(ui_components_1.PageTitle, { className: "title", title: `${terminalNodeName} - ${attributeName}`, titleBadge: react_1.default.createElement(task_view_styles_1.StyledBackArrow, { variant: "chevronLeft", onClick: onGoBack }), buttons: (react_1.default.createElement(react_1.default.Fragment, null, isReEnrichmentInProgress && react_1.default.createElement(generic_1.ReEnrichButton, { loading: true, disabled: true }, t({ key: 'RE_ENRICH_CATEGORY_ACTION_IN_PROGRESS_TITLE' })), react_1.default.createElement(request_full_qa_action_1.RequestFullQAAction, { nodeTitle: terminalNodeName, attributeName: attributeName !== null && attributeName !== void 0 ? attributeName : '' }))) }), isSidebarOpen && (react_1.default.createElement(sidebar_component_1.Sidebar, { attributeName: attributeName, nodeTitle: terminalNodeName, productTreeNodeId: productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.id })), react_1.default.createElement(products_table_1.TaskProductsTable, { attributeName: attributeName, productTreeNode: productTreeNode, nodeTitle: terminalNodeName })));
};
exports.EnrichAIHLQATaskView = EnrichAIHLQATaskView;
